import { Controller } from "@hotwired/stimulus";

export default class UIFilter extends Controller {
  static targets = ["source", "item", "noResults"];

  connect() {}

  filter(event) {
    let filterTerm = this.sourceTarget.value.toLowerCase();
    let visibleCount = 0;
    let excludedCount = 0;

    if (this.hasItemTarget) {
      this.itemTargets.forEach((el, i) => {
        let filterableKey = el.innerText.toLowerCase();
        // An excluded item stays hidden whatever the search term.
        let isExcluded = el.dataset.uiFilterExcluded === "true";

        // Check for case-insensitive substring match
        let isVisible = !isExcluded && filterableKey.includes(filterTerm);
        el.classList.toggle("hidden", !isVisible);

        if (isVisible) {
          visibleCount++;
        }
        if (isExcluded) {
          excludedCount++;
        }
      });
    }

    if (this.hasNoResultsTarget) {
      // A blank search reports nothing unless exclusions are what emptied the list.
      let nothingToReport =
        visibleCount > 0 || (filterTerm === "" && excludedCount === 0);
      this.noResultsTarget.classList.toggle("hidden", nothingToReport);
    }
  }
}
